// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"71e08e9f","113":"a959eb82","127":"7cb91371","136":"3e12f142","151":"3e4bc09a","181":"030b1caf","198":"c1ecefe8","242":"c1a7b543","481":"70d8ee0b","488":"4cb1d538","700":"e2ec0afe","721":"de2b089a","746":"32a3cf7e","941":"02aab22c"}[chunkId] + ".chunk.js";
};